import { render } from "./BdAnniversariesBoard.vue?vue&type=template&id=64b97b54"
import script from "./BdAnniversariesBoard.vue?vue&type=script&lang=js"
export * from "./BdAnniversariesBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__